import React from 'react';
import {Card, Empty} from 'antd';

// Card wrapper reutilizado por todos os gráficos de relatório: título,
// loading, estado vazio e slot `extra` para controles locais (group_by etc).
export default function ReportChartCard({title, extra, loading, isEmpty, children, style}) {
    return (
        <Card title={title} extra={extra} loading={loading} style={{marginBottom: 16, ...style}}>
            {!loading && isEmpty ? (
                <Empty description="Sem dados para o período selecionado" image={Empty.PRESENTED_IMAGE_SIMPLE}/>
            ) : (
                children
            )}
        </Card>
    );
}
